import { useAuthStore } from './authStore'
import { setTimezoneSources } from '@/utils/timezone'

/**
 * Keeps the workspace timezone in step with the signed-in user's tenant. Every login,
 * tenant switch, /auth/me refresh and settings edit writes `user` into the auth
 * store, so one subscription covers them all without touching those call sites.
 * Import this module once at app start (main.tsx).
 */
function sync(user: { tenantTimezone?: string | null } | null): void {
  setTimezoneSources({ tenant: user?.tenantTimezone })
}

sync(useAuthStore.getState().user)
useAuthStore.subscribe(state => sync(state.user))
